import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { MatPaginator } from '@angular/material/paginator';
import { GlobalApiService } from 'src/app/services/global-api.service';

const DIGITAL_SAT_NAME = 'Digital SAT';

@Component({
  selector: 'app-qanda',
  templateUrl: './qanda.component.html',
  styleUrls: ['./qanda.component.scss'],
})
export class QandaComponent implements OnInit {
  testTypes: any[] = [];
  selectedTestType: any = null;
  selectedTestName = '';
  role = localStorage['roleId'];
  searchTable = '';
  tests: any = new MatTableDataSource(<any>[]);
  columnsToDisplay = [
    'test_type',
    'test_code',
    'status',
    'edit',
    'assign',
    'score',
    'analyze',
    'print',
    'duplicate',
    'actions',
  ];
  openTestScoringPattern: boolean = false;
  scoringPatternTestId: number = 0;
  showLoader: boolean = false;
  openDuplicateTestDialog: boolean = false;
  duplicateSourceTest: any = null;
  duplicateTestName: string = '';
  duplicateTestCode: string = '';
  duplicateTestClicked: boolean = false;
  private readonly notifier: NotifierService;
  @ViewChild(MatPaginator, { static: true }) paginator:
    | MatPaginator
    | undefined;
  constructor(
    private httpClient: HttpClient,
    notifierService: NotifierService,
    private globalApiService: GlobalApiService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.tests.paginator = this.paginator;
    this.httpClient
      .get('/api/test_types', {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken'],
        },
      })
      .subscribe(
        (response: any) => {
          console.log(response);
          this.testTypes = response;
        },
        (error) => {
          console.log(error);
          this.notifier.notify('error', 'Unable to fetch test types');
        }
      );
  }

  get isDigitalSat(): boolean {
    return this.selectedTestName === DIGITAL_SAT_NAME;
  }

  applyFilter() {
    console.log(this.searchTable);
    this.tests.filter = this.searchTable.trim().toLowerCase();
  }

  getTests() {
    this.showLoader = true;
    console.log(this.selectedTestType);
    this.selectedTestName =
      this.testTypes[this.selectedTestType]['testTypeName'];
    console.log(this.selectedTestName);
    this.httpClient
      .get(
        `/api/get_tests_by_test_type_id?testTypeId=${
          this.testTypes[this.selectedTestType]['testTypeId']
        }`,
        {
          headers: {
            Authorization: 'Bearer ' + localStorage['accessToken'],
          },
        }
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          this.tests = new MatTableDataSource(response);
          this.tests.paginator = this.paginator;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          console.log(error);
          this.notifier.notify('error', 'Unable to load tests');
        }
      );
  }

  closeTestScoringPattern(event: any) {
    console.log(event);
    this.openTestScoringPattern = event;
    console.log(this.tests);
    console.log(this.scoringPatternTestId);
    if (event === false) {
      this.tests.filteredData.find((scoringPatternTestObj: any) => {
        if (scoringPatternTestObj.testId === this.scoringPatternTestId) {
          console.log(scoringPatternTestObj);
          scoringPatternTestObj.is_conversion_available! = true;
        }
      });
    }
  }

  openDuplicateDialog(test: any) {
    this.duplicateSourceTest = test;
    this.duplicateTestName = `${test.testName || test.testCode || ''} - Copy`;
    this.duplicateTestCode = `${test.testCode || ''}-copy`;
    this.openDuplicateTestDialog = true;
  }

  closeDuplicateDialog() {
    this.openDuplicateTestDialog = false;
    this.duplicateSourceTest = null;
    this.duplicateTestName = '';
    this.duplicateTestCode = '';
    this.duplicateTestClicked = false;
  }

  duplicateTest() {
    if (this.duplicateTestClicked) {
      return;
    }
    if (!this.duplicateTestName.trim() || !this.duplicateTestCode.trim()) {
      this.notifier.notify('error', 'Test name and test code are required');
      return;
    }
    this.duplicateTestClicked = true;
    this.showLoader = true;
    this.globalApiService
      .duplicateTest({
        sourceTestId: this.duplicateSourceTest.testId,
        newTestName: this.duplicateTestName.trim(),
        newTestCode: this.duplicateTestCode.trim(),
      })
      .subscribe({
        next: () => {
          this.duplicateTestClicked = false;
          this.notifier.notify('success', 'Test duplicated successfully!');
          this.closeDuplicateDialog();
          this.getTests();
        },
        error: (error: any) => {
          this.showLoader = false;
          this.duplicateTestClicked = false;
          console.log(error);
          this.notifier.notify(
            'error',
            error?.error?.msg ||
              error?.error?.message ||
              'Unable to duplicate test'
          );
        },
      });
  }
}
